// File: src/utils/saasAnalytics.js

const BASE = 'https://menu.searchisend.in';

// Helper to get or create a persistent visitor fingerprint
export const getFingerprint = () => {
    let fingerprint = localStorage.getItem('saas_visitor_fingerprint');
    if (!fingerprint) {
        // Generate a simple, unique random identifier
        const array = new Uint32Array(4);
        window.crypto.getRandomValues(array);
        fingerprint = Array.from(array, dec => dec.toString(16).padStart(8, '0')).join('');
        localStorage.setItem('saas_visitor_fingerprint', fingerprint);
    }
    return fingerprint;
};

// Helper to detect device type
export const getDeviceType = () => {
    const ua = navigator.userAgent;
    if (/(tablet|ipad|playbook|silk)|(android(?!.*mobi))/i.test(ua)) {
        return 'Tablet';
    }
    if (/Mobile|iP(hone|od)|Android|BlackBerry|IEMobile|Kindle|Silk-Accelerated|(hpw|web)OS|Opera M(obi|ini)/.test(ua)) {
        return 'Mobile';
    }
    return 'Desktop';
};

// Helper to detect platform/OS
export const getPlatform = () => {
    const ua = navigator.userAgent;
    if (/Windows/i.test(ua)) return 'Windows';
    if (/Macintosh|Mac OS X/i.test(ua)) {
        // Distinguish iOS from macOS on iPad
        if (navigator.maxTouchPoints > 0) return 'iOS';
        return 'macOS';
    }
    if (/iPhone|iPad|iPod/i.test(ua)) return 'iOS';
    if (/Android/i.test(ua)) return 'Android';
    if (/Linux/i.test(ua)) return 'Linux';
    return 'Other';
};

// Function to track events
export const logSaasEvent = async (eventName, pageUrl = window.location.pathname) => {
    try {
        const payload = {
            event_name: eventName,
            page_url: pageUrl,
            fingerprint: getFingerprint(),
            referrer: document.referrer || '',
            device: getDeviceType(),
            platform: getPlatform()
        };

        // Try using navigator.sendBeacon first if the browser supports it, otherwise use fetch
        const endpoint = `${BASE}/apimenu/v2/v2_public_analytics.php`;
        if (navigator.sendBeacon) {
            const blob = new Blob([JSON.stringify(payload)], { type: 'application/json' });
            navigator.sendBeacon(endpoint, blob);
        } else {
            fetch(endpoint, {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify(payload)
            }).catch(err => console.warn('Analytics logging failed:', err));
        }
    } catch (error) {
        console.warn('Analytics system error:', error);
    }
};
